import type { RadioGroupProps } from '@sgui-plus/components/radio'
import type { InjectionKey } from 'vue'

export type RadioGroupContext = RadioGroupProps & {
  changeEvent: (val: RadioGroupProps['modelValue']) => void
}

export const RadioGroupContextKey: InjectionKey<RadioGroupContext> = Symbol('RadioGroupContextKey')
